import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=a9ac013e&scoped=true"
import script from "./CardUser.vue?vue&type=script&lang=js"
export * from "./CardUser.vue?vue&type=script&lang=js"
import style0 from "./CardUser.vue?vue&type=style&index=0&id=a9ac013e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ac013e",
  null
  
)

export default component.exports